import { Component, ViewEncapsulation } from '@angular/core';
import { BuildingsStoreService } from '@app/energy-map/services/buildings-store.service';
import { AuthService } from '@app/shared/services/auth.service';
import { Observable } from 'rxjs';
import { filter, shareReplay } from 'rxjs/operators';
import { MapHeaderControlsService } from '../map-header-controls/map-header-controls.service';

@Component({
  selector: 'app-buildings-option-new',
  templateUrl: './new-buildings-option.component.html',
  styleUrls: ['./new-buildings-option.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewBuildingsOptionComponent {
  public buildingsWithNoCoordinatesAndType: Observable<any[]>;
  public buildingsWithNoCoordinates: Observable<any[]>;
  public buildingsWithNoType: Observable<any[]>;

  constructor(public authService: AuthService, private buildingsStoreService: BuildingsStoreService, private mapHeaderControls: MapHeaderControlsService) {
    this.buildingsWithNoCoordinatesAndType = this.buildingsStoreService.buildingsWithNoCoordinatesAndType.pipe(
      filter((building) => !!building),
      shareReplay()
    );
    this.buildingsWithNoCoordinates = this.buildingsStoreService.buildingsWithNoCoordinates.pipe(shareReplay());
    this.buildingsWithNoType = this.buildingsStoreService.buildingsWithNoType.pipe(shareReplay());
  }

  onSelect(building: any) {
    this.buildingsStoreService.selectedBuildingWithUnkownTypeOrGps = building;
    this.mapHeaderControls.closeAll();
  }
}
